import { render, staticRenderFns } from "./FaxOverviewReport.vue?vue&type=template&id=05919acd"
import script from "./FaxOverviewReport.vue?vue&type=script&lang=js"
export * from "./FaxOverviewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports